import { DEFAULT_BIRTHDAY_ON_BACKEND, ZHONGAN_PROVIDER_NAME } from "./chunk-LYAQXCZE.mjs";
import { __export } from "./chunk-QK4PKNB3.mjs"; // src/utils/User.ts

var User_exports = {};

__export(User_exports, {
  getIsDefaultUserBirthday: function getIsDefaultUserBirthday() {
    return _getIsDefaultUserBirthday;
  },
  getIsUserIdentityInsufficient: function getIsUserIdentityInsufficient() {
    return _getIsUserIdentityInsufficient;
  },
  getUserPhone: function getUserPhone() {
    return _getUserPhone;
  },
  getZhonganIdentity: function getZhonganIdentity() {
    return _getZhonganIdentity;
  }
});

import * as R from "ramda";

var _getUserPhone = function _getUserPhone(userData) {
  return R.pipe(R.propOr([], "identities"), R.find(R.propEq("mobile", "provider")), R.propOr("", "uid"))(userData);
};

var _getZhonganIdentity = function _getZhonganIdentity(userData) {
  return R.pipe(R.propOr([], "identities"), R.find(R.propEq(ZHONGAN_PROVIDER_NAME, "provider")))(userData);
};

var _getIsDefaultUserBirthday = function _getIsDefaultUserBirthday(userData) {
  return !(userData !== null && userData !== void 0 && userData.birthday) || userData.birthday === DEFAULT_BIRTHDAY_ON_BACKEND;
};

var _getIsUserIdentityInsufficient = function _getIsUserIdentityInsufficient(userData) {
  var phone = _getUserPhone(userData);

  var zhonganIdentity = _getZhonganIdentity(userData);

  return !phone && !zhonganIdentity;
};

export { _getUserPhone as getUserPhone, _getZhonganIdentity as getZhonganIdentity, _getIsDefaultUserBirthday as getIsDefaultUserBirthday, _getIsUserIdentityInsufficient as getIsUserIdentityInsufficient, User_exports };